
















































import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'RatingScaleReferenceChart',
  setup() {
    const isOpen = ref(false);
    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    return {
      isOpen,
      toggle
    };
  }
});
